<template>
  <div
    id="zones-legend"
  >
    <div style="max-height: 350px">
      <div style="display:flex">
        <v-list class="legend-list">
          <v-list-item
            v-for="zone of zonesLegend"
            :key="zone.id"
            class="zone-container"
            two-line
          >
            <v-list-item-icon>
              <font-awesome-icon
                :icon="zone.active ? 'eye' : 'eye-slash'"
                :style="{backgroundColor: zone.color}"
                class="zone-icon"
                @click="$emit('toggle-zone', zone.id)"
              />
            </v-list-item-icon>
            <v-list-item-content
              class="py-0"
              style="min-height: 35px;"
            >
              <v-list-item-title class="zone-name">
                {{ zone.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="sensor-type">
                {{ zone.sensor.style ? zone.sensor.style.toUpperCase() : 'INACTIVE' }}
                SENSOR
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ZonesLegend',
    props: {
      zonesLegend: Array,
    },
  }
</script>

<style lang="scss" scoped>
.legend-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    margin: 15px 4.3em 15px;
    padding: 0;
    min-height:4rem;
    max-height: 5.2em;
    overflow-y: auto;
    .v-list-item {
      padding-right:0;
      .v-list-item__icon {
        margin:auto;
      }
      .v-list-item__content {
        margin-left:.5rem;
      }
    }
  }
.zone-container {
  flex: 0 1 175px;
  min-height: 0;
  .zone-icon {
    color: white;
    height:2rem;
    width:2rem;
    padding:.35rem;
    border-radius: 5px;
    cursor:pointer;
  }
  .zone-name {
    font-weight:500;
  }
  .sensor-type {
    font-size:.75rem;
    color:#535353;
    font-weight:500;
  }
}
</style>
